import React from "react"
import styled from "styled-components"

import TransitionLink from "~/components/atoms/TransitionLink"
import { Color, IsMobile, LineHeight, SpacingSize } from "~/consts/style-mixins"
import { internalLink, staticPath } from "~/services/helper"

const HREF = internalLink("/new-grads-profile-campaign-2021")

export const FlowMessageForCampaign: React.VFC = () => {
  return (
    <StyledMessage>
      <div>
        <StyledTransitionLink size="Small" icon="Next" href={HREF}>
          <p className="transition-link-inner">
            <img src={`${staticPath("/static/images/amazon-logo.png")}`} className="amazon-logo" />
            <p>プロフィールの対象項目を入力してAmazonギフト3,000円が必ず貰えるキャンペーンに応募しよう</p>
          </p>
        </StyledTransitionLink>
      </div>
    </StyledMessage>
  )
}

const StyledMessage = styled.div`
  display: flex;
  justify-content: center;
  padding: ${SpacingSize.S}px ${SpacingSize.M}px;
  background: #f78620;
  & > div {
    & a,
    svg {
      color: ${Color.White};
      fill: ${Color.White};
    }
  }
  & > div:hover {
    & a,
    svg {
      color: ${Color.White};
      fill: ${Color.White};
    }
  }
`

const StyledTransitionLink = styled(TransitionLink)`
  margin-left: ${SpacingSize["3XS"]}px;
  .transition-link-inner {
    display: flex;
    align-items: center;
    line-height: ${LineHeight.S}%;
  }
  .amazon-logo {
    width: 18px;
    margin-right: 8px;
    ${IsMobile(`
      margin-right: 18px;
    `)}
  }
`
